import { createSlice } from '@reduxjs/toolkit';

export const complianceCheckSlice = createSlice({
  name: 'complianceCheck',
  initialState: {
    compliancedata: {},
  },
  reducers: {
    addComplianceCheckData: (state, action) => {
        console.log(action.payload)
      state.compliancedata = action.payload
    },
  },
});

export const { addComplianceCheckData } = complianceCheckSlice.actions;

export const selectComplianceCheck = state => state.complianceCheck.compliancedata;

export default complianceCheckSlice.reducer;
